/**
 * Shipping Selector - Parcel machine and normal shipping selection
 */

class ShippingSelector {
  constructor() {
    this.selectedMethod = null;
    this.selectedProvider = null;
    this.selectedMachine = null;
    this.parcelMachines = [];
    console.log('ShippingSelector constructor called');
    this.init();
  }

  async init() {
    console.log('ShippingSelector init called');
    this.setupEventListeners();
    await this.loadParcelMachines();
  }

  setupEventListeners() {
    // Shipping method selection
    const methodOptions = document.querySelectorAll('.shipping-method-option');
    console.log('Found shipping method options:', methodOptions.length);

    methodOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        const method = option.dataset.method;
        console.log('Shipping method clicked:', method);
        this.selectShippingMethod(method);
      });
    });

    // Parcel provider selection
    const providerOptions = document.querySelectorAll('.parcel-provider-option');
    console.log('Found provider options:', providerOptions.length);

    providerOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        const provider = option.dataset.provider;
        console.log('Provider clicked:', provider);
        this.selectParcelProvider(provider);
      });
    });

    // Search functionality
    const searchInput = document.getElementById('parcelMachineSearch');
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        this.filterParcelMachines(e.target.value);
      });
    }

    // Change button
    const changeBtn = document.getElementById('shippingChangeBtn');
    if (changeBtn) {
      changeBtn.addEventListener('click', () => {
        this.resetSelection();
      });
    }
  }

  selectShippingMethod(method) {
    console.log('selectShippingMethod called with:', method);
    this.selectedMethod = method;

    // Update UI
    document.querySelectorAll('.shipping-method-option').forEach(option => {
      option.classList.remove('selected');
    });

    const selectedOption = document.querySelector(`[data-method="${method}"]`);
    if (selectedOption) {
      selectedOption.classList.add('selected');
    }

    const radioBtn = document.querySelector(`#shipping_${method}`);
    if (radioBtn) {
      radioBtn.checked = true;
    }

    // Show/hide parcel provider section
    const parcelSection = document.getElementById('parcelProviderSection');
    console.log('Parcel section element:', parcelSection);

    if (method === 'parcel') {
      console.log('Showing parcel provider section');
      if (parcelSection) {
        parcelSection.style.display = 'block';
      }
    } else {
      console.log('Hiding parcel section, saving normal shipping');
      if (parcelSection) {
        parcelSection.style.display = 'none';
      }
      const machineSection = document.getElementById('parcelMachineSection');
      if (machineSection) {
        machineSection.style.display = 'none';
      }
      // For normal shipping, directly save and proceed
      this.saveShippingSelection();
    }
  }

  async selectParcelProvider(provider) {
    console.log('selectParcelProvider called with:', provider);
    this.selectedProvider = provider;

    // Update UI
    document.querySelectorAll('.parcel-provider-option').forEach(option => {
      option.classList.remove('selected');
    });

    const selectedOption = document.querySelector(`[data-provider="${provider}"]`);
    if (selectedOption) {
      selectedOption.classList.add('selected');
    }

    const radioBtn = document.querySelector(`[data-provider="${provider}"] input`);
    if (radioBtn) {
      radioBtn.checked = true;
    }

    // Show parcel machine list
    const machineSection = document.getElementById('parcelMachineSection');
    if (machineSection) {
      machineSection.style.display = 'block';
    }

    // Load provider-specific data
    await this.loadProviderMachines(provider);
    this.renderParcelMachines();
  }

  async loadParcelMachines() {
    // Load Omniva by default for backward compatibility
    await this.loadProviderMachines('omniva');
  }

  async loadProviderMachines(provider) {
    try {
      let assetUrl;

      // Select the correct JSON file based on provider
      if (provider === 'dpd') {
        assetUrl = window.dpdParcelMachinesUrl || '/assets/dpd-parcel-machines.json';
      } else {
        // Default to Omniva
        assetUrl = window.lithuaniaParcelMachinesUrl || '/assets/lithuania-parcel-machines.json';
      }

      console.log(`Loading ${provider} parcel machines from:`, assetUrl);

      const response = await fetch(assetUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      this.parcelMachines = await response.json();
      console.log(`Loaded ${this.parcelMachines.length} ${provider} parcel machines`);
    } catch (error) {
      console.error('Failed to load parcel machines:', error);
      this.parcelMachines = [];

      // Show error in UI
      const listContainer = document.getElementById('parcelMachineList');
      if (listContainer) {
        listContainer.innerHTML = '<p style="text-align: center; color: #ff4444; padding: 20px;">Nepavyko užkrauti paštomatų sąrašo. Prašome perkrauti puslapį.</p>';
      }
    }
  }

  renderParcelMachines(filterText = '') {
    const listContainer = document.getElementById('parcelMachineList');
    if (!listContainer) {
      console.error('parcelMachineList container not found');
      return;
    }

    console.log('Rendering parcel machines, filter:', filterText, 'total:', this.parcelMachines.length);

    // Filter machines
    let machines = this.parcelMachines;
    if (filterText) {
      const searchLower = filterText.toLowerCase();
      machines = machines.filter(machine => {
        // Support both Omniva and DPD formats
        const name = machine.NAME || machine.name || '';
        const city = machine.A3_NAME || machine.city || '';
        const address = machine.A5_NAME || machine.address || '';

        return name.toLowerCase().includes(searchLower) ||
               city.toLowerCase().includes(searchLower) ||
               address.toLowerCase().includes(searchLower);
      });
    }

    // Group by city
    const groupedByCity = {};
    machines.forEach(machine => {
      // Support both Omniva (A3_NAME) and DPD (city) formats
      const city = machine.A3_NAME || machine.city || 'Kiti';
      if (!groupedByCity[city]) {
        groupedByCity[city] = [];
      }
      groupedByCity[city].push(machine);
    });

    // Sort cities alphabetically
    const sortedCities = Object.keys(groupedByCity).sort();

    // Render
    let html = '';
    sortedCities.forEach(city => {
      html += `
        <div class="parcel-city-group">
          <h5 class="parcel-city-name">${city}</h5>
          <div class="parcel-machines-in-city">
      `;

      groupedByCity[city].forEach(machine => {
        // Support both formats
        const name = machine.NAME || machine.name || '';
        const address = machine.address || `${machine.A5_NAME || ''} ${machine.A7_NAME || ''}`.trim();
        const machineId = machine.ZIP || machine.postal_code || '';

        html += `
          <div class="parcel-machine-item" data-machine-id="${machineId}">
            <p class="parcel-machine-name">${name}</p>
            <p class="parcel-machine-address">${address}</p>
          </div>
        `;
      });

      html += `
          </div>
        </div>
      `;
    });

    if (html === '') {
      html = '<p style="text-align: center; color: #888888; padding: 20px;">Nerasta paštomatų</p>';
    }

    listContainer.innerHTML = html;

    // Add click listeners
    const items = listContainer.querySelectorAll('.parcel-machine-item');
    console.log('Added click listeners to', items.length, 'parcel machines');

    items.forEach(item => {
      item.addEventListener('click', () => {
        const machineId = item.dataset.machineId;
        console.log('Parcel machine clicked:', machineId);
        this.selectParcelMachine(machineId);
      });
    });
  }

  filterParcelMachines(searchText) {
    this.renderParcelMachines(searchText);
  }

  selectParcelMachine(machineId) {
    console.log('selectParcelMachine called with:', machineId);
    // Support both formats
    this.selectedMachine = this.parcelMachines.find(m =>
      m.ZIP === machineId || m.postal_code === machineId
    );

    if (!this.selectedMachine) {
      console.error('Parcel machine not found:', machineId);
      return;
    }

    const machineName = this.selectedMachine.NAME || this.selectedMachine.name;
    console.log('Selected machine:', machineName);

    // Update UI
    document.querySelectorAll('.parcel-machine-item').forEach(item => {
      item.classList.remove('selected');
    });

    const selectedElement = document.querySelector(`[data-machine-id="${machineId}"]`);
    if (selectedElement) {
      selectedElement.classList.add('selected');
    }

    // Save selection
    this.saveShippingSelection();
  }

  async saveShippingSelection() {
    console.log('saveShippingSelection called');

    let shippingData = {
      method: this.selectedMethod
    };

    let summaryText = '';

    if (this.selectedMethod === 'parcel' && this.selectedMachine) {
      // Support both Omniva and DPD formats
      const name = this.selectedMachine.NAME || this.selectedMachine.name;
      const address = this.selectedMachine.address || `${this.selectedMachine.A5_NAME || ''} ${this.selectedMachine.A7_NAME || ''}`.trim();
      const city = this.selectedMachine.A3_NAME || this.selectedMachine.city;
      const zip = this.selectedMachine.ZIP || this.selectedMachine.postal_code;

      shippingData.provider = this.selectedProvider;
      shippingData.machine_name = name;
      shippingData.machine_address = address;
      shippingData.machine_city = city;
      shippingData.machine_zip = zip;

      summaryText = `${name} (${address})`;
    } else if (this.selectedMethod === 'normal') {
      summaryText = 'Įprastas pristatymas į namus/biurą';
    }

    console.log('Shipping data to save:', shippingData);

    // Update cart attributes
    try {
      const formData = new FormData();
      formData.append('attributes[shipping_method]', shippingData.method);

      if (shippingData.provider) {
        formData.append('attributes[shipping_provider]', shippingData.provider);
      }
      if (shippingData.machine_name) {
        formData.append('attributes[shipping_machine_name]', shippingData.machine_name);
        formData.append('attributes[shipping_machine_address]', shippingData.machine_address);
        formData.append('attributes[shipping_machine_city]', shippingData.machine_city);
        formData.append('attributes[shipping_machine_zip]', shippingData.machine_zip);
      }

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData)
      });

      if (!response.ok) {
        throw new Error('Failed to update cart');
      }

      console.log('Cart updated successfully');

      // DON'T add shipping product yet - wait until checkout button is clicked
      // Just save the selection to cart attributes and show the summary

      // Show summary
      this.showSummary(summaryText);

      // Update cart shipping display if exists
      const cartShippingDisplay = document.getElementById('cart-shipping-display');
      if (cartShippingDisplay) {
        if (shippingData.method === 'parcel' && shippingData.machine_name) {
          cartShippingDisplay.textContent = shippingData.machine_name;
        } else if (shippingData.method === 'normal') {
          cartShippingDisplay.textContent = 'Įprastas pristatymas';
        }
      }

      // Dispatch event for other components
      window.dispatchEvent(new CustomEvent('shippingSelected', { detail: shippingData }));
    } catch (error) {
      console.error('Failed to save shipping selection:', error);
      alert('Nepavyko išsaugoti pristatymo pasirinkimo. Prašome bandyti dar kartą.');
    }
  }

  // New method: Add shipping product when checkout button is clicked (no reload)
  async addShippingProductForCheckout(shippingData) {
    const config = window.shippingConfig || {};

    console.log('addShippingProductForCheckout called');

    if (!config.autoAddShippingProduct) {
      console.log('Auto-add shipping product is disabled');
      return true;
    }

    // For normal courier, don't add product
    if (shippingData.method === 'normal') {
      console.log('Normal courier - no product needed');
      return true;
    }

    // Get variant ID for the provider
    const provider = shippingData.provider || 'omniva';
    const variantId = config.shippingVariantIds?.[provider] || 0;

    if (!variantId || variantId === 0) {
      alert(`${provider.toUpperCase()} pristatymo būdas dar nesukonfigūruotas.`);
      return false;
    }

    try {
      console.log('Adding shipping product, variant ID:', variantId);

      // Get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Remove any existing shipping products
      const allVariantIds = Object.values(config.shippingVariantIds || {}).filter(id => id && id !== 0);
      const existingShippingItem = cart.items.find(item =>
        item.product_type === 'Shipping' ||
        item.handle === 'shipping' ||
        allVariantIds.includes(item.variant_id)
      );

      if (existingShippingItem) {
        console.log('Removing existing shipping item');
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(existingShippingItem.variant_id), quantity: 0 })
        });
        await new Promise(resolve => setTimeout(resolve, 200));
      }

      // Build properties
      const properties = {
        'Pristatymo būdas': 'Paštomatas',
        'Tiekėjas': provider,
        'Paštomatas': shippingData.machine_name,
        'Adresas': shippingData.machine_address,
        'Miestas': shippingData.machine_city,
        'Pašto kodas': shippingData.machine_zip
      };

      // Add shipping product
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: String(variantId), quantity: 1, properties: properties }]
        })
      });

      if (!addResponse.ok) {
        const errorText = await addResponse.text();
        console.error('Failed to add shipping:', errorText);
        throw new Error('Failed to add shipping product');
      }

      console.log('✓ Shipping product added successfully');
      return true;
    } catch (error) {
      console.error('Error adding shipping product:', error);
      alert('Nepavyko pridėti pristatymo. Prašome bandyti dar kartą.');
      return false;
    }
  }

  async addShippingProduct(shippingData) {
    // Check if shipping product should be added (from config)
    const config = window.shippingConfig || {};

    console.log('addShippingProduct called with config:', config);
    console.log('autoAddShippingProduct:', config.autoAddShippingProduct);

    if (!config.autoAddShippingProduct) {
      console.log('Auto-add shipping product is disabled in config');
      return true; // Return true to allow UI to continue
    }

    // For normal courier shipping, don't add a product - just save to cart attributes
    // Shopify's built-in shipping rates will handle it at checkout
    if (shippingData.method === 'normal') {
      console.log('Normal courier shipping selected - no product will be added, using Shopify shipping rates');
      // No need to add a shipping product, just return success
      // The cart attributes were already saved in saveShippingSelection()
      return true; // Return true - this is successful (no product needed)
    }

    // Determine which variant ID to use for parcel machines
    let variantId = 0;

    if (shippingData.method === 'parcel') {
      // Use provider-specific variant ID for parcel machines
      const provider = shippingData.provider || 'omniva';
      variantId = config.shippingVariantIds?.[provider] || 0;
      console.log(`Selected parcel provider: ${provider}, variant ID: ${variantId}`);

      if (!variantId || variantId === 0) {
        console.warn('Shipping product variant ID not configured for provider:', provider);
        alert(`${provider.toUpperCase()} pristatymo būdas dar nesukonfigūruotas. Prašome susisiekti su administratoriumi arba pasirinkti kitą tiekėją.`);
        return false; // Return false to indicate failure
      }
    }

    console.log('Using variant ID:', variantId);

    try {
      console.log('✓ Proceeding to add shipping product to cart, variant ID:', variantId);

      // First, check if shipping product already exists in cart and remove it
      console.log('Fetching current cart...');
      const cartResponse = await fetch('/cart.js');

      if (!cartResponse.ok) {
        throw new Error('Failed to fetch cart: ' + cartResponse.status);
      }

      const cart = await cartResponse.json();
      console.log('Current cart items:', cart.items.length);

      // Remove ALL shipping products (any provider) before adding new one
      const allVariantIds = Object.values(config.shippingVariantIds || {}).filter(id => id && id !== 0);
      console.log('Looking for existing shipping items with variant IDs:', allVariantIds);

      const existingShippingItem = cart.items.find(item =>
        item.product_type === 'Shipping' ||
        item.handle === 'shipping' ||
        allVariantIds.includes(item.variant_id)
      );

      if (existingShippingItem) {
        console.log('Found existing shipping product, removing it:', existingShippingItem);

        // Use the variant_id instead of key for more reliability
        const removeResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: String(existingShippingItem.variant_id),
            quantity: 0
          })
        });

        if (!removeResponse.ok) {
          console.warn('Failed to remove existing shipping item, but continuing...');
        } else {
          console.log('Remove response: Success');
          // Wait a bit for cart to update
          await new Promise(resolve => setTimeout(resolve, 200));
        }
      } else {
        console.log('No existing shipping product found in cart');
      }

      // Add shipping product with properties (without underscore so they show in checkout)
      const properties = {
        'Pristatymo būdas': shippingData.method === 'parcel' ? 'Paštomatas' : 'Įprastas pristatymas'
      };

      if (shippingData.method === 'parcel' && shippingData.machine_name) {
        properties['Tiekėjas'] = shippingData.provider || '';
        properties['Paštomatas'] = shippingData.machine_name;
        properties['Adresas'] = shippingData.machine_address;
        properties['Miestas'] = shippingData.machine_city;
        properties['Pašto kodas'] = shippingData.machine_zip;
      }

      console.log('Adding shipping product with properties:', properties);
      console.log('Variant ID being added:', variantId);

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: String(variantId),
            quantity: 1,
            properties: properties
          }]
        })
      });

      console.log('Add response status:', addResponse.status);
      console.log('Add response ok:', addResponse.ok);

      if (!addResponse.ok) {
        const errorText = await addResponse.text();
        console.error('Add response error:', errorText);
        throw new Error('HTTP ' + addResponse.status + ': ' + errorText);
      }

      const addResult = await addResponse.json();
      console.log('✓✓✓ Shipping product added successfully!', addResult);

      // Clear the removal flag since we just added shipping successfully
      sessionStorage.removeItem('shouldRemoveShipping');
      sessionStorage.removeItem('shippingProductAdded');

      // Mark that shipping was just added successfully
      sessionStorage.setItem('shippingJustAdded', 'true');

      // Reload the page to show updated cart
      console.log('Reloading page to show updated cart...');

      // Small delay to ensure cart update completes
      await new Promise(resolve => setTimeout(resolve, 300));
      window.location.reload();
    } catch (error) {
      console.error('❌ Failed to add shipping product:', error);
      console.error('Error details:', error.message);
      console.error('Error stack:', error.stack);

      // More user-friendly error message
      let errorMsg = 'Nepavyko pridėti pristatymo. ';
      if (error.message.includes('Failed to fetch')) {
        errorMsg += 'Patikrinkite interneto ryšį ir bandykite dar kartą.';
      } else if (error.message.includes('404')) {
        errorMsg += 'Pristatymo produktas nerastas Shopify sistemoje. Prašome patikrinti, ar produktas sukurtas ir variant ID teisingas.';
      } else if (error.message.includes('422')) {
        errorMsg += 'Negalima pridėti pristatymo produkto. Prašome patikrinti variant ID konfigūraciją.';
      } else {
        errorMsg += error.message;
      }

      alert(errorMsg);

      // Don't reload on error - let user try again
      return false; // Return false to indicate failure
    }
  }

  showSummary(text) {
    const summary = document.getElementById('shippingSelectedSummary');
    const textElement = document.getElementById('shippingSelectedText');

    if (!summary || !textElement) {
      console.warn('Summary elements not found');
      return;
    }

    textElement.textContent = text;
    summary.style.display = 'flex';

    // Hide other sections
    const methodOptions = document.querySelector('.shipping-method-options');
    if (methodOptions) {
      methodOptions.style.display = 'none';
    }

    const parcelSection = document.getElementById('parcelProviderSection');
    if (parcelSection) {
      parcelSection.style.display = 'none';
    }

    const machineSection = document.getElementById('parcelMachineSection');
    if (machineSection) {
      machineSection.style.display = 'none';
    }
  }

  resetSelection() {
    console.log('resetSelection called');
    this.selectedMethod = null;
    this.selectedProvider = null;
    this.selectedMachine = null;

    // Show selection UI
    const methodOptions = document.querySelector('.shipping-method-options');
    if (methodOptions) {
      methodOptions.style.display = 'grid';
    }

    const summary = document.getElementById('shippingSelectedSummary');
    if (summary) {
      summary.style.display = 'none';
    }

    // Reset radio buttons
    document.querySelectorAll('input[name="shipping_method"]').forEach(input => input.checked = false);
    document.querySelectorAll('input[name="parcel_provider"]').forEach(input => input.checked = false);

    // Remove selected classes
    document.querySelectorAll('.selected').forEach(el => el.classList.remove('selected'));
  }
}

// Track if we're on checkout page
function removeShippingProductOnNavigation() {
  console.log('Setting up navigation tracking to remove shipping product');

  // Mark that shipping was properly added
  sessionStorage.setItem('shippingProductAdded', 'true');

  // Listen for page visibility change (more reliable than beforeunload)
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') {
      const proceedingToCheckout = sessionStorage.getItem('proceedingToCheckout');
      const currentUrl = window.location.pathname;
      const isCheckoutPage = currentUrl.includes('/checkout');

      // If we're on checkout page and leaving, always mark for removal
      if (isCheckoutPage) {
        console.log('Leaving checkout page, marking shipping for removal');
        sessionStorage.setItem('shouldRemoveShipping', 'true');
        sessionStorage.removeItem('proceedingToCheckout');
      } else if (proceedingToCheckout !== 'true') {
        console.log('Page hidden and not proceeding to checkout, marking for removal');
        sessionStorage.setItem('shouldRemoveShipping', 'true');
      }
    }
  });

  // Also listen for beforeunload as backup
  window.addEventListener('beforeunload', function() {
    const proceedingToCheckout = sessionStorage.getItem('proceedingToCheckout');
    const currentUrl = window.location.pathname;
    const isCheckoutPage = currentUrl.includes('/checkout');

    // If we're on checkout page and leaving, always mark for removal
    if (isCheckoutPage) {
      console.log('Unloading from checkout page, marking shipping for removal');
      sessionStorage.setItem('shouldRemoveShipping', 'true');
      sessionStorage.removeItem('proceedingToCheckout');
    } else if (proceedingToCheckout !== 'true') {
      console.log('Page unloading and not proceeding to checkout, marking for removal');
      sessionStorage.setItem('shouldRemoveShipping', 'true');
    }
  });

  // Listen for clicks on navigation links - only on cart page
  document.addEventListener('click', function(e) {
    const currentUrl = window.location.pathname;
    const isCartPage = currentUrl.includes('/cart');

    // Only track navigation away from cart page
    if (!isCartPage) {
      return;
    }

    const link = e.target.closest('a');
    if (link && link.href) {
      const href = link.getAttribute('href') || '';

      // If navigating away from cart and not to checkout
      if (!href.includes('checkout') && !href.includes('#') && href !== '') {
        console.log('Clicking navigation link away from cart:', href);
        sessionStorage.setItem('shouldRemoveShipping', 'true');
      }
    }
  });
}

// Remove shipping product if navigating away from checkout
async function checkAndRemoveShippingProduct() {
  const shouldRemove = sessionStorage.getItem('shouldRemoveShipping');
  const currentUrl = window.location.pathname;

  console.log('Checking if should remove shipping product:', shouldRemove);
  console.log('Current URL:', currentUrl);

  // Only run removal if we should remove and we're NOT on checkout page
  const isCartPage = currentUrl.includes('/cart');
  const isCheckoutPage = currentUrl.includes('/checkout');

  // Don't remove if still on checkout
  if (isCheckoutPage) {
    console.log('Still on checkout page, not removing shipping');
    return;
  }

  // ALWAYS remove shipping product when on cart page (not just when shouldRemove flag is set)
  // This ensures leftover shipping products don't persist
  if (isCartPage || shouldRemove === 'true') {
    console.log('Should remove shipping (cart page or flag set), proceeding with removal...');

    try {
      const config = window.shippingConfig || {};

      // Get all possible variant IDs
      const allVariantIds = Object.values(config.shippingVariantIds || {}).filter(id => id && id !== 0);

      if (!allVariantIds.length) {
        console.log('No shipping product variant IDs configured');
        sessionStorage.removeItem('shouldRemoveShipping');
        return;
      }

      console.log('Will remove shipping products with variant IDs:', allVariantIds);

      // Get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Find ANY shipping product (from any provider)
      const shippingItem = cart.items.find(item =>
        item.product_type === 'Shipping' ||
        item.handle === 'shipping' ||
        allVariantIds.includes(item.variant_id)
      );

      if (shippingItem) {
        console.log('Found shipping product, removing:', shippingItem);

        // Remove it
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: shippingItem.key,
            quantity: 0
          })
        });

        console.log('Shipping product removed successfully');

        // Clear cart attributes related to shipping
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              shipping_method: '',
              shipping_provider: '',
              shipping_machine_name: '',
              shipping_machine_address: '',
              shipping_machine_city: '',
              shipping_machine_zip: ''
            }
          })
        });

        console.log('Cart attributes cleared');

        // Only reload if we're on the cart page to show the updated cart
        if (isCartPage) {
          console.log('On cart page, reloading to show updated cart');
          window.location.reload();
        } else {
          console.log('Not on cart page, shipping removed but not reloading');
        }
      } else {
        console.log('No shipping product found in cart');
      }
    } catch (error) {
      console.error('Failed to remove shipping product:', error);
    }

    // Clear the flag after removal
    sessionStorage.removeItem('shouldRemoveShipping');
    sessionStorage.removeItem('shippingProductAdded');
  }
}

// Initialize on page load
(function() {
  console.log('Shipping selector script loaded - VERSION 4.0 with navigation tracking');

  function initShippingSelector() {
    console.log('Attempting to initialize ShippingSelector, readyState:', document.readyState);

    // First, check if we should remove shipping product
    checkAndRemoveShippingProduct();

    // Check if the shipping selector element exists FIRST
    const selectorElement = document.getElementById('shippingSelector');
    if (!selectorElement) {
      console.log('Shipping selector element not found yet, will retry on next event');
      return;
    }

    console.log('Element found!');

    // Check if already properly initialized using a different property name to avoid conflicts
    if (window.shippingSelectorInstance && window.shippingSelectorInstance instanceof ShippingSelector) {
      console.log('ShippingSelector already properly initialized, skipping');
      return;
    }

    console.log('Creating NEW ShippingSelector instance');
    window.shippingSelectorInstance = new ShippingSelector();
    console.log('Instance created successfully!');

    // Set up navigation tracking
    removeShippingProductOnNavigation();
  }

  // Only initialize when DOM is fully ready
  if (document.readyState === 'loading') {
    // DOM still loading, wait for it
    document.addEventListener('DOMContentLoaded', initShippingSelector);
  } else if (document.readyState === 'interactive') {
    // DOM ready but resources still loading, wait for full load
    window.addEventListener('load', initShippingSelector);
  } else {
    // DOM and resources loaded, init now
    initShippingSelector();
  }
})();
